<template>
    <div v-if="!loading" class="pb-2">
        <b-row>
            <b-col md="3" class="mb-2">
                <b-form-input v-model="parameters.id" placeholder="شناسه تیکت" />
            </b-col>
            <b-col md="3" class="mb-2">
                <b-form-input v-model="parameters.searchTerm" placeholder="شناسه مجموعه" />
            </b-col>
            <b-col md="3" class="mb-2">
                <v-select v-model="parameters.status" dir="rtl" placeholder="وضعیت" :options="statusData"
                    :reduce="(value) => value.id" class="bg-white" style="border-radius: 8px;" label="name"
                    :clearable="false">
                    <template #no-options>
                        موردی وجود ندارد
                    </template>
                </v-select>
            </b-col>
            <b-col md="3" class="mb-2">
                <b-button @click="getTickets" variant="primary" class="w-100">اعمال فیلتر</b-button>
            </b-col>
        </b-row>

        <div v-if="tickets.length">
            <b-card class="p-0" no-body>
                <b-overlay :show="loadingPage" variant="transparent" opacity="1" blur="3px" rounded="sm">
                    <b-table responsive :items="tickets" :fields="fields" class="mb-0">
                        <template #cell(status)="data">
                            <b-badge :variant="ticketVariant(data.item.status)">
                                {{ ticketStatus(data.item.status) }}
                            </b-badge>
                        </template>
                        <template #cell(id)="data">
                            <router-link :to="`/tickets/details?id=${data.item.id}`"
                                :class="{ 'text-muted': data.item.status == 2 || data.item.status == 3 }">
                                {{ data.item.id }}
                            </router-link>
                        </template>
                        <template #cell(subject)="data">
                            <div :class="{ 'text-muted': data.item.status == 2 || data.item.status == 3 }">
                                {{ data.item.subject }}
                            </div>
                        </template>
                        <template #cell(details)="data">
                            <router-link :to="`/tickets/details?id=${data.item.id}`">
                                <feather-icon icon="ArrowLeftIcon" size="19"
                                    :class="{ 'text-muted': data.item.status == 2 || data.item.status == 3 }" />
                            </router-link>
                        </template>
                        <template #cell(lastModifiedAt)="data">
                            <div :class="{ 'text-muted': data.item.status == 2 || data.item.status == 3 }">
                                <span>
                                    {{ new Date(data.item.lastModifiedAt).toLocaleTimeString('fa-IR') }}
                                </span>
                                <span> - </span>
                                <span>
                                    {{ new Date(data.item.lastModifiedAt).toLocaleDateString('fa-IR') }}
                                </span>
                            </div>
                        </template>
                    </b-table>
                </b-overlay>
            </b-card>
            <b-pagination align="center" @input="getTickets" v-model="parameters.pageIndex"
                :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />
        </div>
        <h5 v-else class="d-flex align-items-center justify-content-center" style="min-height: 63vh;">
            موردی وجود ندارد
        </h5>

    </div>
</template>

<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BTable, BPagination, BForm, BFormInput, BFormTextarea, BImg, BOverlay, BBadge } from 'bootstrap-vue';
import vSelect from 'vue-select';
import { adminService } from '@core/services';

export default {
    components: {
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BForm,
        BFormInput,
        BFormTextarea,
        BImg,
        BBadge,
        BOverlay,
        vSelect
    },
    data() {
        return {
            loadingPage: false,
            statusData: [
                { name: 'بررسی نشده', id: 0 },
                { name: 'پاسخ داده شده', id: 1 },
                { name: 'بسته شده توسط مجموعه', id: 2 },
                { name: 'بسته شده توسط پشتیبان', id: 3 }
            ],
            tickets: [],
            loading: true,
            fields: [
                {
                    key: 'id',
                    label: 'شناسه',
                },
                {
                    key: 'subject',
                    label: 'عنوان',
                },
                {
                    key: 'storeName',
                    label: 'شناسه مجموعه',
                },
                {
                    key: 'storePhoneNumber',
                    label: 'شماره همراه مدیر',
                },
                {
                    key: 'lastModifiedAt',
                    label: 'تاریخ آخرین به‌روز‌رسانی',
                },
                {
                    key: 'status',
                    label: 'وضعیت',
                },
                {
                    key: 'details',
                    label: 'جزئیات',
                },
            ],
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                id: null,
                status: null,
                searchTerm: null,
                totalCount: null
            },
        }
    },
    computed: {
        ticketStatus() {
            return (status) => {
                if (status == 0) {
                    return 'بررسی نشده'
                }
                if (status == 1) {
                    return 'پاسخ داده شده'
                }
                if (status == 2) {
                    return 'بسته شده توسط مجموعه'
                }
                if (status == 3) {
                    return 'بسته شده توسط پشتیبان'
                }
            }
        },
        ticketVariant() {
            return (status) => {
                if (status == 0) {
                    return 'light-primary'
                }
                if (status == 1) {
                    return 'light-success'
                }
                if (status == 2) {
                    return 'light-secondary'
                }
                if (status == 3) {
                    return 'light-secondary'
                }
            }
        },
    },
    methods: {
        getTickets() {
            this.loadingPage = true
            adminService.getTickets(this.parameters).then(({ data }) => {
                this.parameters.totalCount = data.totalCount
                this.tickets = data.items
                this.loadingPage = false
                this.loading = false;
            })
                .catch(() => { });
        },
    },
    mounted() {
        this.getTickets()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>